<script>
    import KaskiSlider from "../components/KaskiSlider.svelte";

    let slides = [
        {
            id: 1,
            src: "./svelte-site/img/kaskislider/auto.jpg",

        },
        {
            id: 2,
            src: "./svelte-site/img/kaskislider/hiihto.jpg",

        },
        {
            id: 3,
            src: "./svelte-site/img/kaskislider/swim.jpeg",

        },
        {
            id: 4,
            src: "./svelte-site/img/kaskislider/laskettelu.jpg",

        },
        {
            id: 5,
            src: "./svelte-site/img/kaskislider/pilkki.jpg",

        },
        {
            id: 6,
            src: "./svelte-site/img/kaskislider/hiihto.jpg",

        },
        {
            id: 7,
            src: "./svelte-site/img/kaskislider/swim.jpeg",

        },
        {
            id: 8,
            src: "./svelte-site/img/kaskislider/laskettelu.jpg",

        },
        {
            id: 9,
            src: "./svelte-site/img/kaskislider/pilkki.jpg",
        },
        {
            id: 10,
            src: "./svelte-site/img/kaskislider/auto.jpg",

        }
    ];
</script>
<div class="content-container">
    <div class="row">
        <div class="col-xs-12 col-md-5 treeni">
            <div style="margin-left: auto; margin-right: auto; display: block; width: 450px;">
                <h3> Kaski 4.3.2021 klo 18.00 </h3>

                <b>Lämmittely 1</b><br/>
                <ul>
                    <li>Avataan kyykyssä paikat</li>
                    <li>Rintarangas avauksia kyykyssä</li>
                    <li>Takareisivenytysaskellusta</li>
                    <li>Pyöritellään käsiä</li>
                </ul>

                <b>Lämmittely 2 - Amrap 4 - Joka kierroksella yksi toisto lisää</b><br/>
                <ul>
                    <li>Punnerrus olkapääkosketuksilla</li>
                    <li>Askelkyykkyhypyt + Ilmakyykky</li>
                    <li>Istumaannousu</li>
                </ul>

                <b>Treeni 1 - “Hiihtoloma” 20 sek työtä 5 sek vaihto</b><br/>
                <ul>
                    <li>Kyykyssä “Ratinkääntö” kahvakuulalla tai kuminauhalla
                    <li>2 kierrosta näitä:</li>
                    <li>“Hiihto” - Villasukilla</li>
                    <li>“Uidaan” vatsallaan maassa</li>
                    <li>“Lasketellaan” - Viivakyykkyhyppy</li>
                    <li>“Käydään pilkillä”</li>
                    <li>Ajetaan kotiin “Ratinkääntö”</li>
                </ul>

                <b>Treeni 2 - Jotain raskasta - 4 kierrosta - 1.5min per kierros.</b><br/>
                <ul>
                    <li>Mave 20sek -pyyhkeellä staattinen pito</li>
                    <li>Käsiseisontapunnerrus x 5-8</li>
                </ul>

                <b>4 kierrosta - 1.5min per kierros.</b><br/>
                <ul>
                    <li>Kulmasoutu x 5-8 / käsi</li>
                    <li>Voimapyörä villasukilla x 5-8</li>
                </ul>

                <b> Treeni 3 - Leikkimielinen haaste - Laske burpeet</b><br/>
                <b>1.5 min töitä - 1 min taukoa</b><br/>
                <b>4 kierrosta:</b><br/>
                <ul>
                    <li>Ilmakyykky pallolle x 25</li>
                    <li>Vatsarutistus maa ja varvaskosketuksella x 15</li>
                    <li>MAX burpee</li>
                </ul>
            </div>
        </div>
        <div class="col-xs-12 col-md-7">
            <div>
                <KaskiSlider sliderSlides="{slides}" sliderSpeedMs="25000"/>
            </div>
        </div>
    </div>
</div>
<style>
    .treeni {
        padding: 16px 0px 0px 50px;
        line-height: 23px;
    }
</style>